import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { IParagraphField } from '@shared/interfaces';

@Component({
  selector: 'app-paragraph',
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.scss'],
  standalone: false,
})
export class ParagraphComponent implements OnInit {
  @Input() paragraph: IParagraphField;
  @Input() control: FormControl;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit(): void {
    const validators = [];

    if (this.paragraph.isRequired) {
      validators.push(Validators.required);
    }

    validators.push(Validators.maxLength(70));

    this.control.setValidators(validators);
    this.control.updateValueAndValidity();

    // Emit whenever value changes
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
